import parent from './parent';
import parents from './parents';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        parent(selector?: string): HTMLElement | null;
        parents(selector: string): HTMLElement[];
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.parent = function (selector?: string): HTMLElement | null {
    return parent(this, selector);
};

HTMLElement.prototype.parents = function (selector: string): HTMLElement[] {
    return parents(this, selector);
};
